import { render, staticRenderFns } from "./CoinFlowManagement.vue?vue&type=template&id=1cae30d3&scoped=true"
import script from "./CoinFlowManagement.vue?vue&type=script&lang=js"
export * from "./CoinFlowManagement.vue?vue&type=script&lang=js"
import style0 from "./CoinFlowManagement.vue?vue&type=style&index=0&id=1cae30d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae30d3",
  null
  
)

export default component.exports